/**
 *
 * @param {string} phoneNumber
 * @returns {boolean}
 */
export function validatePhoneNumber(phoneNumber) {
  if (phoneNumber.length === 17 && phoneNumber.startsWith('+1 ')) {
    phoneNumber = phoneNumber.slice(3)
  }
  phoneNumber = phoneNumber.replace(/\D/g, '')
  const regex = /^(1|)[2-9]\d{2}[2-9]\d{2}\d{4}$/
  if (regex.test(phoneNumber)) {
    return true
  }
  return false
}
